var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('layout-simple',{attrs:{"title":"views.AuthorizationOverview.title"}},[_c('v-container',[_c('login-card-authorization-overview')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }